function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.476 13.993L16.847 3.437C16.7508 3.30201 16.6238 3.19196 16.4764 3.11603C16.3291 3.0401 16.1657 3.00048 16 3.00048C15.8343 3.00048 15.6709 3.0401 15.5236 3.11603C15.3762 3.19196 15.2492 3.30201 15.153 3.437L8.494 14.043C7.56889 15.5353 7.05357 17.2451 7 19C7 21.3869 7.94821 23.6761 9.63604 25.364C11.3239 27.0518 13.6131 28 16 28C18.3869 28 20.6761 27.0518 22.364 25.364C24.0518 23.6761 25 21.3869 25 19C24.9425 17.2258 24.4167 15.4984 23.476 13.993V13.993ZM16 26C14.1442 25.9976 12.3651 25.2594 11.0529 23.9471C9.74064 22.6349 9.00238 20.8558 9 19C9.05315 17.6016 9.47321 16.2418 10.218 15.057L11.153 13.567L21.227 23.641C20.5727 24.3823 19.7683 24.976 18.8672 25.3829C17.9661 25.7898 16.9887 26.0005 16 26.001V26Z",
  fill: "#250cb0"
});

function SvgHumidity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.0b4a7ea9.svg";
export { ForwardRef as ReactComponent };